// Shared Google Maps JS loader + brand map styling.

const GOOGLE_MAPS_SCRIPT_ID = 'storyfy-google-maps-script'
let scriptPromise: Promise<boolean> | null = null

export const getGoogleMapsApiKey = (): string =>
  (process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '').trim()

export const loadGoogleMaps = (apiKey?: string): Promise<boolean> => {
  const key = (apiKey || getGoogleMapsApiKey()).trim()
  if (!key) return Promise.resolve(false)
  if ((window as any).google?.maps?.places) return Promise.resolve(true)
  if (scriptPromise) return scriptPromise

  scriptPromise = new Promise<boolean>((resolve, reject) => {
    const existing = document.getElementById(
      GOOGLE_MAPS_SCRIPT_ID,
    ) as HTMLScriptElement | null

    if (existing && (window as any).google?.maps?.places) {
      resolve(true)
      return
    }
    if (existing) {
      existing.addEventListener('load', () => resolve(true), { once: true })
      existing.addEventListener('error', reject, { once: true })
      return
    }

    const script = document.createElement('script')
    script.id = GOOGLE_MAPS_SCRIPT_ID
    script.async = true
    script.defer = true
    script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(
      key,
    )}&libraries=places`
    script.onload = () => resolve(true)
    script.onerror = () => reject(new Error('Failed to load Google Maps'))
    document.head.appendChild(script)
  })

  return scriptPromise
}

// Warm, editorial map styling aligned with the Storyfy brand palette
// (paper landscape, white roads, a subtle vermillion highway accent).
export const STORYFY_MAP_STYLE = [
  { elementType: 'geometry', stylers: [{ color: '#F4F1EA' }] },
  { elementType: 'labels.text.fill', stylers: [{ color: '#4B4A44' }] },
  { elementType: 'labels.text.stroke', stylers: [{ color: '#F4F1EA' }] },
  { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
  {
    featureType: 'administrative',
    elementType: 'geometry.stroke',
    stylers: [{ color: '#D8D2C4' }],
  },
  { featureType: 'administrative.land_parcel', stylers: [{ visibility: 'off' }] },
  { featureType: 'poi', stylers: [{ visibility: 'off' }] },
  {
    featureType: 'poi.park',
    elementType: 'geometry',
    stylers: [{ color: '#E3E7D8' }],
  },
  { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#FFFFFF' }] },
  {
    featureType: 'road',
    elementType: 'geometry.stroke',
    stylers: [{ color: '#EBE6DB' }],
  },
  {
    featureType: 'road.arterial',
    elementType: 'geometry',
    stylers: [{ color: '#FBFAF6' }],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry',
    stylers: [{ color: '#F2DDCF' }],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',
    stylers: [{ color: '#E8452A' }, { weight: 0.4 }],
  },
  { featureType: 'transit', stylers: [{ visibility: 'off' }] },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [{ color: '#CBD8D2' }],
  },
  {
    featureType: 'water',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#7A8C86' }],
  },
]
